export { useElementOuterClick } from './use-element-outer-click';
